import { Grid } from "@material-ui/core";
import { APPOINTMENT_TAB, TREATMENT_TAB } from "app/common/LocalConst";
import {
  getDateTime,
  isRoleChiefTechician,
  isRoleTechician,
} from "app/common/LocalFunction";
import { observer } from "mobx-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
const ServiceRequestItemBlock = ({ initialPatient, setCurrentTab }) => {
  const { t } = useTranslation();
  const isRoleCt = isRoleTechician() || isRoleChiefTechician();
  const location = useLocation();
  const isInDetailPage =
    location.pathname === "/treatment-management/treatment-patient-info-detail";
  return (
    <div
      style={{
        backgroundColor: "aliceblue",
        height: "100%",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
      }}
    >
      <Grid
        container
        spacing={1}
        className="m-0 w-100"
        style={{ backgroundColor: "aliceblue" }}
      >
        <Grid item xs={12} className="search-title-card">
          <p className="title-block">Điều trị gần đây</p>
          <div className="flex align-center flex-end gap-1 cursor">
            {!isRoleCt && (
              <p
                className="button-more"
                onClick={() => {
                  if (isInDetailPage) {
                    setCurrentTab(APPOINTMENT_TAB);
                  } else {
                    setCurrentTab(TREATMENT_TAB);
                  }
                }}
              >
                Xem thêm
              </p>
            )}
          </div>
        </Grid>

        <Grid item xs={12}>
          {(initialPatient?.serviceList || []).length > 0 ? (
            (initialPatient?.serviceList || []).map((row, index) => (
              <>
                <Grid
                  key={index}
                  item
                  xs={12}
                  style={{
                    borderBottom: "1px solid gray",
                    padding: "5px",
                    fontSize: "var(--fs-base)",
                  }}
                >
                  <div className="medical-container">
                    <div className="text-medical-container">
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          alignItems: "center",
                        }}
                      >
                        <span className="text-medical">
                          {getDateTime(row?.orderDate)}
                        </span>

                        <span
                          style={{
                            fontSize: "13px",
                            color: "#666",
                            display: "inline",
                          }}
                        >
                          Ghi chú:{" "}
                          <span
                            style={{
                              wordBreak: "break-word",
                            }}
                          >
                            {row?.note}
                          </span>
                        </span>
                      </div>

                      <div className="flex flex-wrap items-center">
                        <span className="name-medical">
                          {row?.service?.name}
                          {/* ({formatMoney(row?.price)}) */}
                          {" | "}
                        </span>

                        {row?.totalPerformedTimes && (
                          <span className="font-size-13 ml-1">
                            Lần điều trị: <b>{row?.totalPerformedTimes || 0}</b>
                            <span className="mx-1">|</span>
                            <b style={{ color: "red" }}>
                              {row?.totalTreatmentTimes || 0}
                            </b>
                          </span>
                        )}
                        {row?.appointment?.startTime && (
                          <>
                            <span className="mx-2 text-gray-400">|</span>
                            <div className="flex justify-center items-center">
                              <span>Hẹn điều trị tiếp:</span>&nbsp;
                              <span className="value-medical">
                                {getDateTime(row.appointment.startTime)} tại{" "}
                                {row?.appointment?.department?.name ||
                                  "Chưa xác định"}
                              </span>
                            </div>
                          </>
                        )}
                        {/* <span className="mx-2 text-gray-400">|</span>
                        <div>
                          <span>Phòng:</span>&nbsp;
                          <span className="value-medical">
                            {row?.room?.name || "Chưa xác định"}
                          </span>
                        </div> */}
                      </div>
                    </div>
                  </div>

                  <div
                    className="flex mt-2 gap-2"
                    style={{ flexDirection: "column" }}
                  >
                    <div>
                      <b>{row?.department?.name}</b>
                    </div>

                    <div>
                      Người thực hiện:&nbsp;
                      {Array.isArray(row?.encounterParticipants) &&
                      row.encounterParticipants.length > 0 ? (
                        row.encounterParticipants.map((participant, index) => {
                          const name = participant?.staff?.staffName;
                          const position = participant?.position?.name;
                          return name ? (
                            <b key={index} className="highlight-staff">
                              {name}
                              {position ? ` (${position})` : ""}
                              {index < row?.encounterParticipants.length - 1
                                ? ", "
                                : ""}
                            </b>
                          ) : null;
                        })
                      ) : (
                        <b>Chưa có người thực hiện</b>
                      )}
                    </div>
                  </div>
                  <div
                    className="flex mt-2 gap-2"
                    style={{ flexDirection: "column" }}
                  >
                    {row?.diagnosticReport?.conclude && (
                      <div>
                        Kết luận: <b>{row.diagnosticReport.conclude}</b>
                      </div>
                    )}

                    {row?.diagnosticReport?.note && (
                      <div>
                        Ghi chú: <b>{row.diagnosticReport.note}</b>
                      </div>
                    )}
                  </div>
                </Grid>
              </>
            ))
          ) : (
            <div className="flex justify-center items-center w-full mt-5">
              Chưa có dữ liệu
            </div>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default memo(observer(ServiceRequestItemBlock));
